<sl-title title="Alternate Host Server Setup"></sl-title>
<h3>Home Server Name: {{ homeDbServerName }}</h3>
<mat-card class="linq-card--legacy">
	<sl-filters [options]="filterOptions" [searchOnly]="searchOnly" [config]="filterConfig" [fields]="filterFields" [filters]="filters"
		[showChipKey]="false" (filtersUpdated)="applyFilter($event)">
		<span class="spacer"></span>
		<sl-title-buttons [buttons]="titleButtons"></sl-title-buttons>
	</sl-filters>
	<sl-table [data]="data" [config]="tableConfig" [filters]="filters">
	</sl-table>
</mat-card>